module.exports = "/static/Images/en/Seven.png";